import { useMemo } from "react";

import axios from "axios";
import {
	handleHeaderInterceptorError,
	headerInterceptor
} from "core/api/interceptors";

import { APP_CONSTANTS } from "../config/appConstants";

const useAxios = () => {
	const axiosClient = useMemo(() => {
		const axiosInstance = axios.create({
			baseURL: process.env.NX_PUBLIC_BFF_URL,
			timeout: APP_CONSTANTS.TIMEOUT_API_RESPONSE
		});

		axiosInstance.interceptors.request.use(
			headerInterceptor,
			handleHeaderInterceptorError
		);

		return axiosInstance;
	}, []);

	return axiosClient;
};

export { useAxios };
